import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { IProps, IState } from './types';
import commonService from 'utils/commonService';
import service from 'bff/services/fireProdService';
import { CodeId } from 'constants/enums/codeId.enum';
// import moment from 'moment';
import moment from 'moment-timezone';
import InsTypeDefines from 'constants/models/insTypeDefines';
import { InsType } from 'constants/enums/insType.enum';
import { ApplyType } from 'constants/enums/applyType.enum';
import { SysOption } from 'bff/models/info';
import _ from 'lodash';
import { SysOptParamId } from 'constants/enums/sysOptParamId.enum';
import { PolicyDelivery } from 'constants/enums/policyDelivery.enum';
import { PdfExportContent } from 'bff/models/product';
import { ExpType } from 'constants/enums/expType.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { PaymentMethod } from 'constants/enums/paymentMethod.enum';
import { PayerContent } from 'bff/models/member/boPayby';
import { RuleCheckInsuredType } from 'constants/enums/ruleCheckInsuredType.enum';
import { setGameQualifyModalVisibleAction } from 'redux/actions/modal.action';
import { GameChkqualifyResp } from 'bff/models/game/gameChkqualify';
import { GamePOI } from 'constants/enums/gamePOI.enum';
import gameService from 'bff/services/gameService';

class InsureProcessSuccess extends React.Component<IProps, IState> {
  state: IState = {
    insDoneCode: new Array(0),
    insDoneBarCode: new Array(0),
    emailNotifySysOpts: new Array(0),
    docIdSysOpts: new Array(0),
    policyDeliverySysOpts: new Array(0),
    barCodeUrl: ''
  }

  componentDidMount = async () => {
    commonService.scrollToTop();

    // 若繳費方式選擇行動條碼，且為網要時，取得繳費條碼路由
    const { tempPaymentFormValue } = this.props.tempPayment;
    const { tempFillState, tempFillFormValue } = this.props.tempFill;
    let barCodeUrl = '';
    if (
      tempPaymentFormValue &&
      tempFillState &&
      tempFillFormValue &&
      tempFillState.applyType === ApplyType.WebRequire &&
      tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode) {
      const policyHolder = { ...tempFillFormValue.POLICYHOLDERS[0] };

      barCodeUrl = await service.fetchBarcodeUrl(tempFillState.serialNo, policyHolder.POLICYHOLDER_NAME);
    }

    // 補繳費
    if (
      tempPaymentFormValue &&
      tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode &&
      this.props.boPayby.APPLY_NO
    ) {
      const policyholders =
        _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant);

      barCodeUrl = await service.fetchBarcodeUrl(this.props.boPayby.APPLY_NO, policyholders[0].NAME);
    }

    const initSetting = await service.fetchInitSuccess(tempPaymentFormValue?.PAYMENT_METHOD || '');
    // console.log('initSetting', initSetting);

    // 若是以帳戶轉帳或信用卡支付且有要保號，走到此頁視為「已繳款」，則查詢抽獎資格
    if (
      tempFillState &&
      tempFillState.serialNo &&
      tempPaymentFormValue &&
      (tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BankAccount || tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.CreditCard)) {
      const _applyNo = tempFillState.serialNo;
      const args = {
        GAMEPOI: GamePOI.INSURE,
        APPLY_NO: _applyNo
      };
      const response = await gameService.gameChkqualify(args);
      if (response && response.QUALIFIED_DCNT > 0) {
        // 顯示抽獎資格提示跳窗
        this.props.setGameQualifyModalVisible(true, GamePOI.INSURE, _applyNo, response);
      }
    }

    this.setState({
      insDoneCode: [...initSetting.insDoneCode],
      insDoneBarCode: [...initSetting.insDoneBarCode],
      emailNotifySysOpts: [...initSetting.emailNotifySysOpts],
      docIdSysOpts: [...initSetting.docIdSysOpts],
      policyDeliverySysOpts: [...initSetting.policyDeliverySysOpts],
      barCodeUrl: barCodeUrl
    });
    // console.log('temp State', JSON.stringify(this.props.tempState));
  }

  /**
   * @description 付款方式為代碼繳費 取得 CodeTable 訊息，替換對應區塊值
  */
  handleFormatBarMsg = (codeId: string, ...params: any) => {
    const msg = commonService.getCodeMsg(this.state.insDoneBarCode, codeId);
    if (!msg) return '';

    return this.handleGetMsgInfo(msg, ...params);
  }

  /**
   * @description 取得 CodeTable 訊息，替換對應區塊值
  */
  handleFormatMsg = (codeId: string, ...params: any) => {
    const msg = commonService.getCodeMsg(this.state.insDoneCode, codeId);
    if (!msg) return '';

    return this.handleGetMsgInfo(msg, ...params);
  }

  /**
   * @description 取得顯示文字
   */
  handleGetMsgInfo = (msg: string, ...params: any) => {
    if (params && params.length > 0) {
      for (let i = 0; i < params.length; i += 1) {
        msg = msg.replace(`{#PARAM${i + 1}}`, params[i]);
      }
    }

    return msg;
  }

  /**
   *@description 取得系統參數值
  */
  handleGetSysMsg = (sysOpts: SysOption[], paramId: string) => {
    return _.find(sysOpts, (sysOpt: SysOption) => sysOpt.PARAM_ID === paramId)?.PARAM_VALUE;
  }

  /**
   * @description 取得保單寄送方式文字
  */
  handleGetDeliveryText = (type: string) => {
    return _.find(this.state.policyDeliverySysOpts, (sysOpt: SysOption) => sysOpt.PARAM_VALUE === type)?.PARAM_TEXT;
  };

  /**
   * @description 取得保單寄送方式參數值
  */
  handleGetDeliveryType = (delivery: string) => {
    return delivery === PolicyDelivery.Electric
      ? SysOptParamId.EMAIL_NOTIFY_PODELIVER_EPAPER
      : SysOptParamId.EMAIL_NOTIFY_PODELIVER_PAPER;
  };

  /**
   * @description 下載要保書
   */
  handleDownload = async () => {
    let serialNo;
    let prodId;
    if (this.props.boPayby.APPLY_NO) {
      serialNo = this.props.boPayby.APPLY_NO;
      prodId = this.props.boPayby.PROD_ID;
    }

    if (
      this.props.tempFill &&
      this.props.tempFill.tempFillState &&
      this.props.tempSelect &&
      this.props.tempSelect.tempSelectState
    ) {
      serialNo = this.props.tempFill.tempFillState.serialNo;
      prodId = this.props.tempSelect.tempSelectState.activeProdId;
    }

    if (!serialNo || !prodId) return;

    const docId = this.handleGetSysMsg(this.state.docIdSysOpts, prodId);

    // console.log('serialNo', serialNo);
    // console.log('docId', docId);

    const applyFormReqContent: PdfExportContent = {
      APPLY_NO: serialNo || '',
      DOC_ID: docId || '',
      EXPTYPE: ExpType.OnlyRequire
    };

    const fileUrl = await service.downloadApplyForm(applyFormReqContent);
    if (!fileUrl) return;

    let fileName = '';
    if (fileUrl.indexOf('/') !== -1) {
      const lastIndex = fileUrl.lastIndexOf('/');
      fileName = fileUrl.substring(lastIndex + 1);
    }

    try {
      commonService.downloadFile(fileUrl, fileName);
    } catch {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '下載失敗',
        html: '無法取得相關資訊'
      });
    }
  }

  /**
   * @description 開新分頁至繳費頁
  */
  handleRedirectBarcodePage = async () => {
    if (!this.state.barCodeUrl) return;

    window.open(this.state.barCodeUrl);
  }

  render () {
    const { tempFillState, tempFillFormValue } = this.props.tempFill;
    const { tempSelectState } = this.props.tempSelect;
    const { tempBuildingInfoFormValue } = this.props.tempBuildingInfo;
    const { tempPaymentFormValue } = this.props.tempPayment;

    /**
   * @description 取得網投完成訊息
   */
    const handleWebInsuredSuccessMsg = () => {
      const { tempPaymentFormValue } = this.props.tempPayment;
      if (!tempPaymentFormValue) return;

      let applicantName;
      if (this.props.boPayby.APPLY_NO) {
        const policyholders =
          _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant);

        applicantName = policyholders[0].NAME;
      }

      if (this.props.tempFill && this.props.tempFill.tempFillFormValue) {
        const policyholders = [...this.props.tempFill.tempFillFormValue.POLICYHOLDERS];

        applicantName = policyholders[0].POLICYHOLDER_NAME;
      }

      if (!applicantName) return;
      let msg = '';
      if (tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode) {
        msg = this.handleFormatBarMsg(CodeId.B001, moment().format('YYYY/MM/DD HH:mm'), InsTypeDefines[InsType.Fire]);
      }

      if (!msg) {
        msg = this.handleFormatMsg(CodeId.B001, moment().format('YYYY/MM/DD HH:mm'), InsTypeDefines[InsType.Fire]);
      }

      return (
        <p>
          {`親愛的${applicantName}您好：`}<br />
          <span>{commonService.htmlParser(msg)}</span>
        </p>
      );
    };

    /**
     * @description 取得網要完成訊息
     */
    const handleWebRequireSuccessMsg = () => <p>{commonService.htmlParser(this.handleFormatMsg(CodeId.B006))}</p>;

    /**
     * @description 取得保險內容區塊
    */
    const handleCreateInsuredInfo = () => {
      let insureds;
      let insuredName;
      let startDate;
      let endDate;
      let serialNo;
      let fee;
      let delivery;
      if (this.props.boPayby.APPLY_NO) {
        insureds =
          _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);
        insuredName = insureds[0].NAME;
        startDate = this.props.boPayby.START_DATE;
        endDate = this.props.boPayby.END_DATE;
        serialNo = this.props.boPayby.APPLY_NO;
        fee = this.props.boPayby.POLICY_FEE;
        delivery = this.props.boPayby.POLICY_DELIVERY;
      }

      if (tempFillState && tempFillFormValue && tempSelectState && tempBuildingInfoFormValue) {
        insureds = [...tempFillFormValue.INSUREDS];
        insuredName = insureds[0].INSURED_NAME;
        startDate = moment(tempBuildingInfoFormValue.INSURED_DATE);
        endDate = moment(tempBuildingInfoFormValue.INSURED_DATE).add(1, 'y');
        serialNo = tempFillState.serialNo;
        fee = tempSelectState.evalFireRes.TOTAL_FEE;
        delivery = tempFillFormValue.DELIVERY;
      }

      if (!insureds || insureds.length === 0 || !startDate || !endDate || !serialNo || !delivery) return;

      return (
        <div className="element__list">
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">網路投保交易序號</div>
              <div className="element__list-group-content">{serialNo}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">被保險人姓名</div>
              <div className="element__list-group-content">{`${insuredName}`}{insureds.length > 1 ? ` 等${insureds.length}人` : ''}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">交易金額</div>
              <div className="element__list-group-content">{`NT$ ${commonService.thousandFormat(`${fee}`)} 元`}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">保單寄送方式</div>
              <div className="element__list-group-content">
                {
                  `${this.handleGetDeliveryText(delivery)}:${this.handleGetSysMsg(this.state.emailNotifySysOpts, this.handleGetDeliveryType(delivery))}`
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">保險期間</div>
              <div className="element__list-group-content">{`${moment(startDate).format('YYYY/MM/DD')} 12:00 ~ ${moment(endDate).format('YYYY/MM/DD')} 12:00`}</div>
            </div>
          </div>
        </div>
      );
    };

    /**
     * @description 取得投保完成訊息3
     */
    const handleSuccessMsg4th = () => {
      const msg = this.handleGetSysMsg(this.state.emailNotifySysOpts, SysOptParamId.EMAIL_NOTIFY_CUSTOM_SERVICE);
      if (!msg) return null;

      let msgInfo: any = msg;

      if (msg.indexOf('：') !== -1) {
        const msgArray = msg.split('：');

        msgInfo = _.map(msgArray, (msg: string, index: number) => {
          return React.cloneElement(
            <>
              {msg} <br />
            </>
            , { key: index });
        });
      }

      return <p>{msgInfo}</p>;
    };

    return (
      <div className="insure-process-success">
        {/* 投保完成 */}
        <div className="insured-complete">
          <img src="https://ensureuat.wwunion.com/ensure/images/Ah_want_I04.png" alt="住火險投保完成示意圖" width={250} />
          <div className="insured-complete__content">
            {
              tempFillState && tempFillState.applyType === ApplyType.WebInsured && (
                <div className="insure-process-success__part">
                  {handleWebInsuredSuccessMsg()}
                </div>
              )
            }
            {
              tempFillState &&
              tempFillState.applyType === ApplyType.WebRequire && (
                <div className="insure-process-success__part">
                  {handleWebRequireSuccessMsg()}
                </div>
              )
            }
            {
              this.props.boPayby &&
              this.props.boPayby.BC_TYPE &&
              this.props.boPayby.BC_TYPE === ApplyType.WebRequire && (
                <div className="insure-process-success__part">
                  {handleWebRequireSuccessMsg()}
                </div>
              )
            }
            {
              tempPaymentFormValue &&
              tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode && (
                <div className="insure-process-success__part">
                  <p>{commonService.htmlParser(commonService.getCodeMsg(this.state.insDoneBarCode, CodeId.B003))}</p>
                </div>
              )
            }
          </div>
          <div className="insured-complete__controls">
            {
              tempPaymentFormValue &&
              tempFillState &&
              tempFillState.applyType === ApplyType.WebRequire &&
              tempPaymentFormValue.PAYMENT_METHOD !== PaymentMethod.BarCode && (
                <button type="button" className="element__button element__button--red" onClick={this.handleDownload}>要保書下載</button>
              )
            }
            {
              // 補繳費
              tempPaymentFormValue &&
              this.props.boPayby &&
              this.props.boPayby.BC_TYPE &&
              this.props.boPayby.BC_TYPE === ApplyType.WebRequire &&
              tempPaymentFormValue.PAYMENT_METHOD !== PaymentMethod.BarCode && (
                <button type="button" className="element__button element__button--red" onClick={this.handleDownload}>要保書下載</button>
              )
            }
            {
              tempPaymentFormValue &&
              tempFillState &&
              tempFillState.applyType === ApplyType.WebRequire &&
              tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode && (
                <button type="button" className="element__button element__button--red" onClick={this.handleRedirectBarcodePage}>繳費單連結</button>
              )
            }
            {
              tempPaymentFormValue &&
              this.props.boPayby &&
              this.props.boPayby.BC_TYPE &&
              this.props.boPayby.BC_TYPE === ApplyType.WebRequire &&
              tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode && (
                <button type="button" className="element__button element__button--red" onClick={this.handleRedirectBarcodePage}>繳費單連結</button>
              )
            }
          </div>
        </div>
        {/* 保險內容 */}
        <div className="insurance-content">
          <div className="insurance-content__title">保險內容</div>
          <div className="insurance-content__content">
            <div className="insurance-content__list">
              {
                handleCreateInsuredInfo()
              }
            </div>
            <div className="insurance-content__reminder-text">
              {
                tempPaymentFormValue &&
                tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode && (
                  <div className="insure-process-success__part">
                    <p>{commonService.htmlParser(commonService.getCodeMsg(this.state.insDoneBarCode, CodeId.B004))}</p>
                  </div>
                )
              }
              <div className="insure-process-success__part">
                {
                  handleSuccessMsg4th()
                }
              </div>
              {
                tempPaymentFormValue &&
                tempPaymentFormValue.PAYMENT_METHOD !== PaymentMethod.BarCode && (
                  <div className="insure-process-success__part">
                    <p>{commonService.htmlParser(commonService.getCodeMsg(this.state.insDoneCode, CodeId.B003))}</p>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setGameQualifyModalVisible:
    (visible: boolean, gamePoi: string, applyNo: string, checkResult: GameChkqualifyResp) =>
      dispatch(setGameQualifyModalVisibleAction(visible, gamePoi, applyNo, checkResult))
});

export default connect(null, mapDispatchToProps)(InsureProcessSuccess);
